import { i18n as Ii18n } from 'i18next';

export const translateWithFallback = (key: string, fallbackText: string, i18n: Ii18n) => {
    if (i18n.exists(key)) {
        return i18n.t(key);
    }

    return fallbackText;
};
